import { FC } from "react";
import { XCircle, CheckCircle } from "lucide-react";

export interface AdminObservationOutcomeBadgeProps {
	className?: string;
	observationType: IObservationType;
	isCompliant?: boolean;
	isPassedThreshold?: boolean;
	isCompleted?: boolean;
	overallScore?: number | null;
	overallScoreBreakdown?: string | undefined;
}

const badgeBase =
	"inline-flex items-center gap-2 py-2 px-4 text-white rounded-lg";

const AdminObservationOutcomeBadge: FC<AdminObservationOutcomeBadgeProps> = ({
	observationType,
	isCompliant,
	isCompleted,
	isPassedThreshold,
	overallScore,
	overallScoreBreakdown,
	className
}) => {
	if (observationType === "INDIVIDUAL" && isCompliant !== undefined) {
		return (
			<div className={className}>
				<span
					className={`${badgeBase} ${isCompliant ? "bg-green-700" : "bg-destructive"}`}
				>
					{isCompliant ? (
						<CheckCircle size={20} data-testid="md-outline-check-circle" />
					) : (
						<XCircle size={26} data-testid="md-close-circle-outline" />
					)}

					<span>{isCompliant ? "Compliant" : "Not compliant"}</span>
				</span>
			</div>
		);
	}

	if (
		observationType === "STORE_SCORED_ASSESSMENT" &&
		isPassedThreshold !== undefined
	) {
		return (
			<div className={className}>
				<span
					className={`${badgeBase} ${isPassedThreshold ? "bg-green-700" : "bg-destructive"}`}
				>
					{isPassedThreshold ? (
						<CheckCircle size={20} data-testid="md-outline-check-circle" />
					) : (
						<XCircle size={26} data-testid="md-close-circle-outline" />
					)}

					<span>{isPassedThreshold ? "Passed" : "Failed"}</span>
				</span>
			</div>
		);
	}

	if (
		observationType === "STORE_SELF_ASSESSMENT" &&
		isCompleted !== undefined
	) {
		return (
			<div className={className}>
				<span
					className={`${badgeBase} ${isCompleted ? "bg-green-700" : "bg-destructive"}`}
				>
					{isCompleted ? (
						<CheckCircle size={20} data-testid="md-outline-check-circle" />
					) : (
						<XCircle size={26} data-testid="md-close-circle-outline" />
					)}

					<span>{isCompleted ? "Completed" : "Not complete"}</span>
				</span>
			</div>
		);
	}

	if (observationType === "GREAT_CONVERSATION") {
		return (
			<div className="flex items-center justify-between">
				<div className={className}>
					<span className={`${badgeBase} bg-black`}>
						<span className="text-white font-normal text-base">
							Overall Score:
						</span>
						<span className="text-white text-base">
							{overallScoreBreakdown && <>{overallScoreBreakdown} | </>}
							{overallScore}%
						</span>
					</span>
				</div>
			</div>
		);
	}
	return null;
};

export default AdminObservationOutcomeBadge;
